export const STUDENT_QUIZ = '/student_quiz_assessment/'
export const STUDENT_QUIZ_ALL = `${STUDENT_QUIZ}all` as const
export const STUDENT_QUIZ_BY_ID = `${STUDENT_QUIZ}get` as const
export const STUDENT_QUIZ_SAVE = `${STUDENT_QUIZ}save` as const
export const STUDENT_QUIZ_SELECT = `${STUDENT_QUIZ}select` as const
export const STUDENT_QUIZ_SUBMIT = `${STUDENT_QUIZ}submit` as const
export const STUDENT_QUIZ_START = `${STUDENT_QUIZ}start` as const
export const STUDENT_QUIZ_SUBMIT_MANUAL = `${STUDENT_QUIZ_SUBMIT}-manual` as const
